<template>
	<!-- Displays a list of products and a sidebar -->
	<Loading :loading="loading" class="row" id="listing">
		<div class='col-12 col-md-11 offset-md-1'>
			<Breadcrumbs class="p-0"/>
			<div class="col-12 row m-0">
				<!-- scrollTo is scroll point for pagination change-->
				<div class="col-12 col-md-3 p-0 align-items-center">
					<router-link
						:to="{name: 'discountPartners'}"
						class="backToParent btn btn-outline-primary"
					>&lt; See all Locations</router-link>
				</div>
				<h1 id="scrollTo" class="col-12 col-md-6 text-center">{{listingName}}</h1>
			</div>
		</div>


		<div class="row">	
			<div class="sidebar offset-1 col-md-2 col-11">
				<div class="sidebarInner">
					<SubsubcategoryFilter :products="products" :allProducts="listingData"/>
				</div>
			</div>
			<!-- <ListingSidebar :allProducts="listingData" :products="products"/> -->
			<div class="col-12 col-md-8">
				<!-- <div class="row">
					<Breadcrumbs/>
				</div> -->
				<div class="row productListingOptions">
					<div class="col-8 col-md-4 showCount">
						Show:
						<span
							v-for="option in showOptions"
							:key="option"
							@click="() => {itemsPerPage = option; pageNumber = 0;}"
							:class="{current: itemsPerPage == option}"
							class="displayOption"
						>
							<span class="displayOptionText">{{option == 10000 ? 'All' : option}}</span>
						</span>
					</div>
					<div class="sorting col-4">
						<span
							v-for="option in sortingOptions"
							:key="option[0]"
							@click="() => {sortingAlgo = option[0]; pageNumber = 0;}"
							:class="{current: sortingAlgo == option[0]}"
							class="displayOption"
						>
							<span class="displayOptionText">{{option[1]}}</span>
						</span>
					</div>
					<div class="col-12 col-md-4">
						<SearchBar :searchFunc="(val) => {this.search = val}" placeholder="Search Discount Partners" ref="searchBar" />
					</div>
				</div>

				<div class="row">
					<div v-if="products.length > 0" class="col-12">
						<transition-group
							name="fade"
							type="out-in"
							tag="div"
							class="col-12 itemContainer align-items-center"
							appear
						>
							<div v-for="product in products" class="col-12 discountPartnerItem" :key="product.id">
								<div class="row">
									<div class="col-12 col-md-6">
										<div class="row">
											<router-link
											:to="{name:'discountPartnerSingle', params:{discountPartner: product.id}, query:{backName: listingName, backRoute: $route.fullPath, location: $route.params.location}}"
											class="noStyle"
											>
											<h2 class="col-12 textRed itemTitle">{{product.title}}</h2>
											</router-link>
										</div>
										<div class="row d-none d-md-inline-block">
											<div class="col-12">
											<span
												class="description"
												v-html="product.description.replace(/(<([^>]+)>)/ig,'').substring(0, 200)"
											></span>
											<router-link
												:to="{name:'discountPartnerSingle', params:{discountPartner: product.id}, query:{backName: listingName, backRoute: $route.fullPath, location: $route.params.location}}"
											>...More</router-link>
											</div>
										</div>
									</div>
									<div class="col-12 col-md-3 order-md-first text-center text-md-left">
										<img v-if="product.images" :src="imageUrl(product.images[0].sizes, 'small')">
									</div>
									<div class="col-12 col-md-3 text-center">
										<div
											class="offerText"
											v-if="product.discount_partner_extra_text"
										>
											{{product.discount_partner_extra_text}}
										</div>
										<router-link
											:to="{name:'discountPartnerSingle', params:{discountPartner: product.id}, query:{backName: listingName, backRoute: $route.fullPath, location: $route.params.location}}"
											class="btn btn-primary"
										>
											Learn More
										</router-link>
									</div>
								</div>
							</div>
						</transition-group>
						<PaginationButtons :pageNumber="pageNumber" :pageCount="pageCount"/>
					</div>
					<div v-else class="col-12 text-center my-3">
						<p>We couldn't find any Discount Partners matching your search</p>
						<p>Try clearing your filters</p>
						<ClearFiltersButton class="btn btn-primary" :extraFunc="() => {this.search = ''; this.$refs.searchBar.clear()}"/>
					</div>
				</div>
			</div>
		</div>
		<vue-headful :title="listingName + ' | Cherrytree'"/>
	</Loading>
</template>

<script>
import { mapState } from "vuex";
import { fetchDiscountPartners } from "@/network/listingRequests";

import SubsubcategoryFilter from "@/sections/shop/listing/ListingSidebarSubSubCategoryFilter";

import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";
import Loading from "@/components/loading/Loading";

import PaginationButtons from "@/components/paginationButtons";

import { filterListing } from "@/sections/shop/listing/filterListing";

import { imageUrl } from "@/utils";

import ClearFiltersButton from "@/components/buttons/ClearFiltersButton";

import SearchBar from "@/components/searchBar";

export default {
  name: "ProductListing",
  components: {
    PaginationButtons,
    Loading,
    // ListingSidebar,
    SubsubcategoryFilter,
    Breadcrumbs,
    ClearFiltersButton,
    SearchBar
  },
  data: () => {
    return {
      search: "",
      listingData: [], //will hold data about listing
      loading: false,
      itemsPerPage: 24, //default
      sortingAlgo: "TitleAZ" //sort A-Z by default
    };
  },
  //called every time the before component is shown
  created() {
    this.getData();
  },
  methods: {
    imageUrl,
    getData() {
      this.loading = true;
      var query_data = {
        listingId: this.$route.params.location // get listing id from url/router
      };
      fetchDiscountPartners(
        query_data,
        listing => {
          this.listingData = Object.values(listing);
          this.loading = false;
        },
        error => {
          console.log(error);
        }
      );
    }
  },
  watch: {
    //check if the items have changed and if they have then reset pagination to 0
    filtered: function(oldItems, newItems) {
      if (oldItems.length == newItems.length) {
        for (let i = 0; i < oldItems.length; i++) {
          if (oldItems[i] != newItems[i]) {
            this.pageNumber = 0;
            return;
          }
        }
      } else {
        this.pageNumber = 0;
      }
    },
    // check if category/subcategory has changed and fetch new data if so
    "$route.params"(oldVal, newVal) {
      if (oldVal.toString() == newVal.toString()) {
        return;
      }
      this.getData();
    }
  },
  computed: {
    ...mapState({
      // map categories to store.reference.categories
      categories: state => state.reference.categories
    }),
    listingId() {
      return this.$route.params.subcategory;
    },
    filtered() {
      //setup refine id
      let { priceHigh, priceLow, brand, refine } = this.$route.query;
      let search = this.search;
      let price_key = "member_price";

      return filterListing(
        this.listingData,
        priceHigh,
        priceLow,
        brand,
        refine,
        search,
        null,
        price_key
      );
    },
    sortingOptions() {
      let options = [];

      options.push(["TitleAZ", "A-Z"]);
      options.push(["TitleZA", "Z-A"]);

      //   //only available to logged in
      //   if (this.$store.state.auth.loggedIn) {
      //     options.push(["priceLowHigh", "Lowest Price"]);
      //     options.push(["priceHighLow", "Highest Price"]);
      //   }

      //   options.push(["biggestSaving", "Biggest Saving"]);
      return options;
    },
    sorted() {
      let sortingAlgo = () => {};

      let priceKey = this.$store.state.auth.memberLevel;

      try {
        switch (this.sortingAlgo) {
          case "priceLowHigh":
            sortingAlgo = (a, b) =>
              a.prices[priceKey].price - b.prices[priceKey].price;
            break;
          case "priceHighLow":
            sortingAlgo = (a, b) =>
              b.prices[priceKey].price - a.prices[priceKey].price;
            break;
          case "TitleAZ":
            sortingAlgo = (a, b) => a.title.localeCompare(b.title);
            break;
          case "TitleZA":
            sortingAlgo = (a, b) => b.title.localeCompare(a.title);
            break;
          case "biggestSaving":
            sortingAlgo = (a, b) =>
              b.prices.savings_percentages.gold -
              a.prices.savings_percentages.gold;
            break;
          default:
            throw new Error(
              "Invalid sorting algorithm " + this.sortingAlgorithm
            );
        }
        return this.filtered.slice().sort(sortingAlgo); //make copy before sorting
      } catch {
        console.error("error sorting ", this.sortingAlgo);
        return this.filtered;
      }
    },
    paginated() {
      const start = (this.pageNumber - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.sorted.slice(start, end);
    },
    pageCount() {
      let l = this.filtered.length,
        s = this.itemsPerPage;
      return Math.ceil(l / s);
    },
    pageNumber: {
      get() {
        if (this.$route.query && this.$route.query.page) {
          return parseInt(this.$route.query.page);
        }
        return 1;
      },
      //when page number is set, update query param in route
      set(val) {
        // eslint-disable-next-line
        const { page, ...oldQuery } = this.$route.query;
        if (val === 0 || val === undefined || val === 1) {
          //remove page from query params if page number is 0
        //   this.$router.push({ query: { ...oldQuery } });
        } else {
          this.$router.push({ query: { page: val, ...oldQuery } });
        }
      }
    },
    products() {
      return this.paginated;
    },
    brands() {
      var listingArray = Object.values(this.listingData);
      return listingArray.filter(listing => {
        return parseFloat(listing.retail_price) == 0;
      });
    },
    listingName() {
      const catId = 1635;
      const subcatId = this.$route.params.location;
      if (!catId || !subcatId || !this.categories) {
        return "";
      }
      return this.categories[catId].children[subcatId].category;
    },
    showOptions() {
      let options = [12, 24, 48, 100, 10000];
      return options;
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-active {
  transition: all 0.5s ease;
  transition-delay: 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// .fade-move{
//   background:red;
// }

.listingTitle {
  margin: 20px 0 20px 30px;
}

.itemContainer {
  overflow: hidden;
}

.productListingOptions {
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 0.8em;
}

.displayOption {
  &:not(:last-of-type)::after {
    content: " - ";
  }
}

.displayOptionText {
  cursor: pointer;
}

.displayOption.current .displayOptionText {
  text-decoration: underline;
  font-weight: bold;
}

.discountPartnerItem {
  padding: 20px;
}

.itemTitle {
  &:hover {
    text-decoration: underline;
  }
}

.backToParent {
  display: inline-block;
  //margin-left: 20px;
  margin: 20px 0;
}

.discountPartnerItem {
  img {
    max-width: 100%;
    height: auto;
  }
  .description img {
    display: none;
  }
}

.offerText {
  font-weight: bold;
  color: $CTred;
  font-size: 1.6em;
  margin-bottom: 10px;
}

@include media-breakpoint-down(sm){
  .listingTitle{
    margin: 20px 0;
  }
}
</style>
